import axios from 'axios';
import { put, takeLatest, call } from 'redux-saga/effects';
//types
import * as types from '../ActionTypes/GymTvActionTypes';
import { gymTv } from '../../BusinessLogic/Network/API/GymTvApi';
import { GymTvActionCreators } from '../ActionCreators/GymTvActionCreators';

export class GymTvSaga {
    static *getGymTvChannels() {
        try {
            const _gymTv = gymTv.create();
            const { data: response } = yield call(axios, _gymTv.getGymTvChannels());
            yield put(GymTvActionCreators.getGymTvChannelsSuccess(response.data));
        } catch (error) {
            yield put(GymTvActionCreators.getGymTvChannelsFailed(error));
        }
    }

    static *getGymTvChannelById({ meta: { channelId, callback } }) {
        try {
            const _gymTv = gymTv.create();
            const { data: response } = yield call(axios, _gymTv.getGymTvChannelById(channelId));
            yield put(GymTvActionCreators.getGymTvChannelByIdSuccess(response.data));
            if (callback) yield callback(response.data.room_number);
        } catch (error) {
            yield put(GymTvActionCreators.getGymTvChannelByIdFailed(error));
        }
    }

    static *createGymTvChannel() {
        try {
            const _gymTv = gymTv.create();
            const { data: response } = yield call(axios, _gymTv.createGymTvChannel());
            yield put(GymTvActionCreators.createGymTvChannelSuccess(response.data));
        } catch (error) {
            yield put(GymTvActionCreators.createGymTvChannelFailed(error));
        }
    }

    static *updateGymTvChannel({ meta: { channelId, channelData } }) {
        try {
            const _gymTv = gymTv.create();
            const { data: response } = yield call(axios, _gymTv.updateGymTvChannel(channelId, channelData));
            yield put(GymTvActionCreators.updateGymTvChannelSuccess(response.data));
        } catch (error) {
            yield put(GymTvActionCreators.updateGymTvChannelFailed(error));
        }
    }

    static *deleteGymTvChannel({ meta: { channelId } }) {
        try {
            const _gymTv = gymTv.create();
            const { data: response } = yield call(axios, _gymTv.deleteGymTvChannel(channelId));
            yield put(GymTvActionCreators.deleteGymTvChannelSuccess(response.data));
        } catch (error) {
            yield put(GymTvActionCreators.deleteGymTvChannelFailed(error));
        }
    }

    static *duplicateGymTvChannel({ meta: { channelId } }) {
        try {
            const _gymTv = gymTv.create();
            const { data: response } = yield call(axios, _gymTv.duplicateGymTvChannel(channelId));
            yield put(GymTvActionCreators.duplicateGymTvChannelSuccess(response.data));
        } catch (error) {
            yield put(GymTvActionCreators.duplicateGymTvChannelFailed(error));
        }
    }

    static *addGymTvChannelItem({ meta: { channelId, itemData, callback } }) {
        try {
            const _gymTv = gymTv.create();
            const { data: response } = yield call(axios, _gymTv.addGymTvChannelItem(channelId, itemData));
            yield put(GymTvActionCreators.addGymTvChannelItemSuccess(response.data));
            if (callback) yield callback(response.data.id);
        } catch (error) {
            yield put(GymTvActionCreators.addGymTvChannelItemFailed(error));
        }
    }

    static *deleteGymTvChannelItem({ meta: { channelId, itemId } }) {
        try {
            const _gymTv = gymTv.create();
            const { data: response } = yield call(axios, _gymTv.deleteGymTvChannelItem(channelId, itemId));
            yield put(GymTvActionCreators.deleteGymTvChannelItemSuccess(response.data));
        } catch (error) {
            yield put(GymTvActionCreators.deleteGymTvChannelItemFailed(error));
        }
    }

    static *updateGymTvChannelItem({ meta: { channelId, itemId, itemData } }) {
        try {
            const _gymTv = gymTv.create();
            const { data: response } = yield call(axios, _gymTv.updateGymTvChannelItem(channelId, itemId, itemData));
            yield put(GymTvActionCreators.updateGymTvChannelItemSuccess(response.data));
        } catch (error) {
            yield put(GymTvActionCreators.updateGymTvChannelItemFailed(error));
        }
    }

    static *getGymTvClassesByRoomNumber({ meta: { roomNumber, callback } }) {
        try {
            const _gymTv = gymTv.create();
            const { data: response } = yield call(axios, _gymTv.getGymTvClassesByRoomNumber(roomNumber));
            yield put(GymTvActionCreators.getGymTvClassesByRoomNumberSuccess(response.data));
            if (callback) yield callback();
        } catch (error) {
            yield put(GymTvActionCreators.getGymTvClassesByRoomNumberFailed(error));
        }
    }
}

export function* saga() {
    // channels
    yield takeLatest(types.GET_GYM_TV_CHANNELS_REQUEST, GymTvSaga.getGymTvChannels);
    yield takeLatest(types.CREATE_GYM_TV_CHANNEL_REQUEST, GymTvSaga.createGymTvChannel);
    yield takeLatest(types.GET_GYM_TV_CHANNEL_BY_ID_REQUEST, GymTvSaga.getGymTvChannelById);
    yield takeLatest(types.UPDATE_GYM_TV_CHANNEL_REQUEST, GymTvSaga.updateGymTvChannel);
    yield takeLatest(types.DUPLICATE_GYM_TV_CHANNEL_REQUEST, GymTvSaga.duplicateGymTvChannel);
    yield takeLatest(types.DELETE_GYM_TV_CHANNEL_REQUEST, GymTvSaga.deleteGymTvChannel);

    // channel items
    yield takeLatest(types.ADD_GYM_TV_CHANNEL_ITEM_REQUEST, GymTvSaga.addGymTvChannelItem);
    yield takeLatest(types.UPDATE_GYM_TV_CHANNEL_ITEM_REQUEST, GymTvSaga.updateGymTvChannelItem);
    yield takeLatest(types.DELETE_GYM_TV_CHANNEL_ITEM_REQUEST, GymTvSaga.deleteGymTvChannelItem);

    // classes
    yield takeLatest(types.GET_GYM_TV_CLASSES_BY_ROOM_NUMBER_REQUEST, GymTvSaga.getGymTvClassesByRoomNumber);
}



// WEBPACK FOOTER //
// ./src/Store/Saga/GymTvSaga.js